import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/SideBar";
import "../styles/hoc/Layout.css";

function Layout() {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarExpanded(!isSidebarExpanded);
  };

  return (
    <div className="layout">
      <Sidebar expanded={isSidebarExpanded} toggleSidebar={toggleSidebar} />
      <main
        className={`main-content ${
          isSidebarExpanded ? "sidebar-expanded" : "sidebar-collapsed"
        }`}
      >
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;
